import React from 'react'
import {
    PromotionalCard,
    CardOrientationOptions,
} from 'component-library/cards/PromotionalCard/PromotionalCard'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import { CardRouteProps } from 'component-library/cards/card-props.routing'
import { ImpressionAvailable } from 'component-library/__helpers/impression-available-helper'
import { MediaMode } from '../CardMedia/CardMedia'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { createCollectionAvailableEvent } from 'common/events/collection-events'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

type PromotionalCardRoutingProps = CardRouteProps & {
    verticalSpacing?: keyof ThemeMargins
    hasPadding?: boolean
    mediaMode?: MediaMode
    showCTA?: boolean
    cardOrientation: CardOrientationOptions
    mobileOnly?: true
}

export const PromotionalCardRegistration = createRegisterableComponentWithData(
    'promotional-card',
    ContentDataDefinitionLoader,
    (props: PromotionalCardRoutingProps, data, services) => {
        if (data.loaded && data.result.publications.length === 0) {
            // Can happen if we are driven by a curation and publication(s) have been killed
            // or curation metadata which can be empty by choice
            return null
        }

        const results = data.loaded && data.result.publications[0]
        if (results && results.cardType !== 'publication') {
            return null
        }

        return (
            <ImpressionAvailable
                loading={!data.loaded}
                available={() => {
                    if (!data.loaded) {
                        console.warn('Available should never be called when loading is true')
                        return
                    }

                    services.onEvent(
                        createCollectionAvailableEvent(data.result.publications, 'PromotionalCard')
                    )
                }}
            >
                {ref => (
                    <PromotionalCard
                        innerRef={ref}
                        item={results ? { loaded: true, result: results } : { loaded: false }}
                        fixedRatio={props.fixedRatio}
                        fontScale={props.fontScale}
                        onEvent={services.onEvent}
                        hasPadding={props.hasPadding}
                        hideTeaser={props.hideTeaser}
                        verticalSpacing={props.verticalSpacing}
                        cardNumber={1}
                        mediaMode={props.mediaMode}
                        showCTA={props.showCTA}
                        cardOrientation={props.cardOrientation}
                        mobileOnly={props.mobileOnly}
                    />
                )}
            </ImpressionAvailable>
        )
    }
)
